import styled from 'styled-components';

export const Switcher = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 16px;
  line-height: 1.25em;
  font-weight: 600;
  color: var(--grey70);
`;

export const Divider = styled.div`
  width: 1px;
  height: 18px;
  background: #949fac;
  margin: 0 17px;
  position: relative;
  top: 2px;
`;

export const Link = styled.div`
  color: var(--blue100);
  font-size: 16px;
  line-height: 1.25em;
  cursor: pointer;

  &:hover {
    color: var(--blue120);
  }
`;

export const List = styled.div``;

export const ListItem = styled.div``;
